import { render, staticRenderFns } from "./LoginV2.vue?vue&type=template&id=b2f5e722&scoped=true&"
import script from "./LoginV2.vue?vue&type=script&lang=js&"
export * from "./LoginV2.vue?vue&type=script&lang=js&"
import style0 from "./LoginV2.vue?vue&type=style&index=0&id=b2f5e722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f5e722",
  null
  
)

export default component.exports